/**
 * The scope taxonomy the API key dialog renders. Mirrors `API_KEY_SCOPE_TREE` in torqagent-core;
 * the server validates whatever is submitted, so a drift here shows up as a 400 rather than a key
 * with the wrong reach. (WF-2657)
 */
export interface ScopeGroup {
  key: string
  label: string
  allScope: string
  children: Array<{ scope: string; label: string }>
}

export const SCOPE_GROUPS: ScopeGroup[] = [
  {
    key: 'teammates',
    label: 'Teammates',
    allScope: 'teammates:all',
    children: [
      { scope: 'teammates:read', label: 'Read' },
      { scope: 'teammates:write', label: 'Write' },
      { scope: 'teammates:chat', label: 'Chat' },
    ],
  },
  {
    key: 'tools',
    label: 'Tools',
    allScope: 'tools:all',
    children: [{ scope: 'tools:read', label: 'Read' }],
  },
  {
    key: 'teams',
    label: 'Teams',
    allScope: 'teams:all',
    children: [
      { scope: 'teams:read', label: 'Read' },
      { scope: 'teams:write', label: 'Write' },
      { scope: 'teams:run', label: 'Run' },
    ],
  },
  {
    key: 'language-models',
    label: 'Language Models',
    allScope: 'language-models:all',
    children: [{ scope: 'language-models:read', label: 'Read' }],
  },
]

/**
 * Selecting a group's `:all` selects every child under it. Deselecting any child deselects `:all`
 * but leaves the other children alone — selecting all the children while leaving `:all` off is a
 * valid, deliberately more restrictive choice, because `:all` also grants scopes added later.
 */
export function toggleScope(selected: string[], scope: string, checked: boolean): string[] {
  const group = SCOPE_GROUPS.find(g => g.allScope === scope || g.children.some(c => c.scope === scope))
  if (!group) {
    return selected
  }
  const set = new Set(selected)

  if (scope === group.allScope) {
    if (checked) {
      set.add(group.allScope)
      group.children.forEach(child => set.add(child.scope))
    } else {
      set.delete(group.allScope)
    }
    return [...set]
  }

  if (checked) {
    set.add(scope)
  } else {
    set.delete(scope)
    // A child that is no longer held cannot be covered by `:all` either.
    set.delete(group.allScope)
  }
  return [...set]
}
